import * as React from 'react';
import { Stack, StackChildren, Text } from '@doordash/design-language';
import ContactSalesStrings from '../ContactSalesStrings';
import { WrappedLink } from '../../../core/Common/NavButton';
import { selfServeRoutes } from '../../../core/AppStructure/PublicRoutes';
var strings = ContactSalesStrings.thankYouDisplay;
export var ThankYouDisplay = function (_a) {
    var showAdHocMessage = _a.showAdHocMessage;
    var AdhocBody = function () { return (
    // use Interpolate later
    React.createElement(React.Fragment, null,
        "If you are looking to feed your team right away, sign up",
        ' ',
        React.createElement(WrappedLink, { target: "_blank", href: selfServeRoutes.SIGN_UP_TEAM_ROUTE }, "here"),
        ' ',
        "for a self-serve account to start ordering. ",
        strings.adHocBody())); };
    return (React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall },
        React.createElement(Text, { styles: Text.Styles.PageTitle2 }, strings.title()),
        React.createElement(Text, { styles: Text.Styles.Label2 }, showAdHocMessage ? React.createElement(AdhocBody, null) : strings.body())));
};
export default ThankYouDisplay;
